import { render } from "./TelemedicineContentEs.vue?vue&type=template&id=936893e8&scoped=true"
import script from "./TelemedicineContentEs.vue?vue&type=script&lang=js"
export * from "./TelemedicineContentEs.vue?vue&type=script&lang=js"

import "./TelemedicineContentEs.vue?vue&type=style&index=0&id=936893e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-936893e8"]])

export default __exports__